import React from 'react';
import $ from 'jquery';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import Spinner from 'LIBRARY/CommonResources/SpinnerLoader/Spinner';
import LibraryApiCall from 'LibraryApiCall';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import { Link } from 'react-router-dom';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import advanceFilter from "LIBRARY/CommonResources/images/advanceFilter.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';
import AdvanceFilterIcon from "LIBRARY/CommonResources/images/advanceFilterIcon.png";
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import filterIcon from 'LIBRARY/CommonResources/images/filterIcon.svg';
import { connect } from 'react-redux';


class UserWiseIssuedReturnResource extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All user wise issued return resource report List
            userWiseIssueReturnListLoading: false,
            userWiseIssueReturnListData: {},
            totalDataItem: 0,
            pageIndex: 1,
            limit: "10",

            // filter field values
            userType: 'Instructor',
            searchByAcademicYear: '',
            searchByProgram: '',  // department program
            searchByUserName: '',
            searchEmployeeMember: '',
            searchBySemester: '',
            searchByParentGroup: '',
            searchByDepartment: '',  // department

            academicYearSequence: [],  // academic year data
            academicYearList: [],
            academicYearArray: {},

            GetStreamList: {},
            loadingStreamData: false,

            programListArray: {},
            loadingProgramData: false,

            loadingEmployeeData: false,
            employeeListData: [],

            semesterListArray: {},
            loadingStreamGroupData: false,

            parentGroupListArray: {},
            loadingParentGroupData: false,

            loadingStudentData: false,
            studentListData: [],

            //filter button 
            showFilterModal: false,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Type", isVisible: true },
                { name: "Resource Type", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: 'Accession No.', isVisible: true },
                { name: 'Title', isVisible: true },
                { name: "Issue Date", isVisible: true },
                { name: "Due Date", isVisible: true },
                { name: "Return Date", isVisible: true },
                { name: "Applicable Fine", isVisible: true },
                { name: "Collected Fine	", isVisible: true },
                { name: "Waived Fine	", isVisible: true },
                { name: "Balance Fine	", isVisible: true },
                { name: "Policy Name", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { label: "Type", key: 'type' },
                { label: "Resource Type", key: 'resourceType' },
                { label: "Accession Series", key: 'accessionSeries' },
                { label: 'Accession No.', key: 'accessionNo' },
                { label: 'Title', key: 'title' },
                { label: "Issue Date", key: 'issueDate' },
                { label: "Due Date", key: 'dueDate' },
                { label: "Return Date", key: 'returnDate' },
                { label: "Applicable Fine	", key: 'applicableFine	' },
                { label: "Collected Fine", key: 'collectedFine' },
                { label: "Waived Fine", key: 'waivedFine' },
                { label: "Balance Fine", key: 'balanceFine' },
                { label: "Policy Name", key: 'policyName' }
            ],

            exportItemVisibility: [
                { label: "Type", isVisible: true },
                { name: "Resource Type", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: 'Accession No.', isVisible: true },
                { name: 'Title', isVisible: true },
                { name: "Issue Date", isVisible: true },
                { name: "Due Date", isVisible: true },
                { name: "Return Date", isVisible: true },
                { name: "Applicable Fine", isVisible: true },
                { name: "Collected Fine	", isVisible: true },
                { name: "Waived Fine	", isVisible: true },
                { name: "Balance Fine	", isVisible: true },
                { name: "Policy Name", isVisible: true }
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],
        };
    }

    componentDidMount() {
        this.apiCallToGetAcademicYearList(); // academic list
        this.GetInstituteDepartment(); // institute department
        this.GetInstituteStreamsObject(); // department program
        this.formatCSVExportData('onLoad');
    }

    // METHOD TO GET ACADEMIC YEAR LIST
    apiCallToGetAcademicYearList = async () => {
        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetAcademicYearListObject',
            requestData,
            '/api/admission/streamManagement.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAcademicYearList();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                // Map the apiData to the desired format
                const formattedData = Object.keys(apiResult).map(key => ({
                    yearID: key,
                    yearName: apiResult[key].year_text
                }));

                this.setState({
                    academicYearArray: formattedData,
                    academicYearList: apiResult,
                    academicYearSequence: jsonResponse.APIResult.sortedIdArray,
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting academic year list. Please try again later.'
                });
            }
        }
    }

    // API CALL TO GET get Institute departments List
    GetInstituteDepartment = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "delete_status": "active"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteDepartment',
            requestData,
            "/api/settings/instituteDepartments.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteDepartment();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.data,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET get departments program List
    GetInstituteStreamsObject = async () => {
        this.setState({
            loadingProgramData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "facultyId": config.faculty_id,
            "departmentForFilter": this.state.searchByDepartment,
            "showParentGroupData": true,
            "sidArray": []
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetInstituteStreamsObject',
            requestData,
            "/api/admission/streamManagement.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetInstituteStreamsObject();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    programListArray: apiResult.data,
                    loadingProgramData: false,
                })
            } else {
                this.setState({
                    loadingProgramData: false,
                })
            }
        }
    }

    // User Type : Instructor

    // filter academic year on change
    handleInstructorAcdYearChange = (event) => {
        this.setState({
            pageIndex: 1, limit: "10", searchByAcademicYear: event.target.value, searchByUserName: '',
            userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {}, searchByProgram: ''
        }
        );
    };

    // filter program on change
    handleInstructorProgramChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByProgram: event.target.value, searchByUserName: '', userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {}, }
            , () => {
                this.getEmployeeDetails();  // employee details
            }
        );
    };

    // filter user on change
    handleFilterUserChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByUserName: event.target.value, }
            , () => {
                this.GetUserWiseIssuedResourceListForReport();  // employee details
            }
        );
    };

    // API CALL TO GET get employee details List
    getEmployeeDetails = async () => {
        this.setState({
            loadingEmployeeData: true,
        })
        let requestData = {
            "institute_id": config.institute_id,
            "department": this.state.searchByProgram,
            "search": this.state.searchEmployeeMember
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getEmployeeDetails',
            requestData,
            "/api/employee/employee.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.getEmployeeDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    employeeListData: apiResult.data,
                    loadingEmployeeData: false,
                })
            } else {
                this.setState({
                    employeeListData: [],
                    loadingEmployeeData: false,
                })
            }
        }
    }

    // API CALL TO GET get user wise issued return resources List
    GetUserWiseIssuedResourceListForReport = async () => {
        this.setState({
            userWiseIssueReturnListLoading: true,
        })

        let userIdValue = this.state.searchByUserName ? (this.state.searchByUserName).value : '';
        let userRoleValue = ''
        if (this.state.searchByUserName.role == "Teaching") {
            userRoleValue = "teaching"
        } else if (this.state.searchByUserName.role == "Non-teaching") {
            userRoleValue = "nonteaching"
        } else {
            userRoleValue = "student"
        }

        let requestData = {
            "iid": config.institute_id,
            "pageIndex": this.state.pageIndex,
            "limitPerPage": this.state.limit,
            "userId": userIdValue,
            "Role": userRoleValue,
            "iidArray":this.props.iidArray.iidArray
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetUserWiseIssuedResourceListForReport',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetUserWiseIssuedResourceListForReport();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    userWiseIssueReturnListData: apiResult.data,
                    totalDataItem: apiResult.totalRecords,
                    userWiseIssueReturnListLoading: false,
                })
            } else {
                this.setState({
                    userWiseIssueReturnListData: {},
                    totalDataItem: 0,
                    userWiseIssueReturnListLoading: false,
                })
            }
        }
    }

    // User Type : Learner

    // filter academic year on change
    handleLeanerAcdYearChange = (event) => {
        this.setState({
            pageIndex: 1, limit: "10", searchByAcademicYear: event.target.value, searchByProgram: '', searchByUserName: '', userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {}, employeeListData: {}, searchEmployeeMember: '',
            searchByDepartment: '', searchByParentGroup: '', searchBySemester: ''
        }
            , () => {
                this.GetGroupList();  // group/semester details
            }
        );
    };

    // filter program on change
    handleLearnerProgramChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByProgram: event.target.value, searchByParentGroup: '', searchBySemester: '', searchByUserName: '', userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {} }
            , () => {
                this.GetParentGroupList();  // employee details
            }
        );
    };

    // filter department on change
    handleDepartmentChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByDepartment: event.target.value, searchBySemester: '', searchByProgram: '', searchByParentGroup: '', searchByUserName: '', userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {} }
            , () => {
                this.GetInstituteStreamsObject();  // program
            }
        );
    };

    // filter parent group on change
    handleParentGroupChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByParentGroup: event.target.value, searchBySemester: '', searchByUserName: '', userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {} }
            , () => {
                this.GetGroupList();  // group/semester details
            }
        );
    };

    // filter semester/group on change
    handleFilterSemesterChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchBySemester: event.target.value, searchByUserName: '', userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {} },
            () => {
                this.GetStudentList();  // student details
            }
        );
    };

    // API CALL TO GET get parent group data
    GetParentGroupList = async () => {
        this.setState({
            loadingParentGroupData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "sidArray": [this.state.searchByProgram],
            "pageIndex": this.state.pageIndex,
            "limitPerPage": 500
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetParentGroupList',
            requestData,
            "/api/admission/groupDetails.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetParentGroupList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    parentGroupListArray: apiResult.data,
                    loadingParentGroupData: false,
                })
            } else {
                this.setState({
                    loadingParentGroupData: false,
                })
            }
        }
    }

    // API CALL TO GET get group data
    GetGroupList = async () => {
        this.setState({
            loadingStreamGroupData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "sidArray": [
                this.state.searchByProgram
            ],
            "pageIndex": "all",
            "limitPerPage": "all",
            "parentGroupId": this.state.searchByParentGroup,
            "academicIdArray": [
                this.state.searchByAcademicYear,
            ]
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetGroupList',
            requestData,
            "/api/admission/groupDetails.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetParentGroupList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    semesterListArray: apiResult.data,
                    loadingStreamGroupData: false,
                })
            } else {
                this.setState({
                    loadingStreamGroupData: false,
                })
            }
        }
    }

    // API CALL TO GET get student details List
    GetStudentList = async () => {
        this.setState({
            loadingStudentData: true,
        })
        let requestData = {
            "iid": config.institute_id,
            "sid": this.state.searchByProgram,
            "acayr": this.state.searchByAcademicYear,
            "groupid": this.state.searchBySemester,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getStudentList',
            requestData,
            "/api/instructor/events.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetStudentList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    studentListData: apiResult.studentList,
                    loadingStudentData: false,
                })
            } else {
                this.setState({
                    studentListData: [],
                    loadingStudentData: false,
                })
            }
        }
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByAcademicYear: this.state.searchByAcademicYear, searchByProgram: this.state.searchByProgram, searchByUserName: this.state.searchByUserName }, () => {
            this.GetUserWiseIssuedResourceListForReport();
        });
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({ pageIndex: 1, limit: event.target.value, searchByAcademicYear: this.state.searchByAcademicYear, searchByProgram: this.state.searchByProgram, searchByUserName: this.state.searchByUserName }, () => {
            this.GetUserWiseIssuedResourceListForReport();
        });
    }

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByAcademicYear: '', searchByProgram: '', searchByUserName: '', userType: 'Instructor', limit: "10", pageIndex: 1,
            userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {}, employeeListData: {}, searchEmployeeMember: '',
            searchByDepartment: '', searchByParentGroup: '', searchBySemester: ''
        }
            , () => {
                this.apiCallToGetAcademicYearList();
                this.GetInstituteStreamsObject();
                this.getEmployeeDetails();
            }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterUserType = this.state.userType
        let filterAcademicYear = Object.values(this.state.academicYearArray)?.filter((data) => data?.yearID == this.state.searchByAcademicYear)
        let filterProgram = Object.entries(this.state.programListArray)
            ?.filter(([id, data]) => id == this.state.searchByProgram)
            .map(([id, data]) => data.stream_name)
        let filterUserName = Object.values(this.state.employeeListData)?.filter((data) => data?.FacultyId == this.state.searchByUserName.value)
        let filterDepartment = Object.values(this.state.GetStreamList)?.filter((data) => data?.unique_id == this.state.searchByDepartment)
        let filterParentGroup = Object.entries(this.state.parentGroupListArray)
            ?.filter(([id, data]) => id == this.state.searchByParentGroup)
            .map(([id, data]) => data.groupName)
        let filterGroup = Object.entries(this.state.semesterListArray)
            ?.filter(([id, data]) => id == this.state.searchBySemester)
            .map(([id, data]) => data.groupName)
        let filterStudentName = Object.values(this.state.studentListData)?.filter((data) => data?.id == this.state.searchByUserName.value)

        if (filterUserType) {
            FilterArray.push(`User Type - ${filterUserType}`)
        }
        if (this.state.searchByAcademicYear && filterAcademicYear.length > 0) {
            FilterArray.push(`Academic Year - ${filterAcademicYear[0].yearName}`)
        }
        if (this.state.searchByProgram && filterProgram.length > 0) {
            FilterArray.push(`Program - ${filterProgram[0]}`)
        }
        if (this.state.searchByUserName && filterUserName.length > 0) {
            FilterArray.push(`Instructor Name - ${filterUserName[0].FirstName} ${filterUserName[0].LastName} | ${filterUserName[0].usertextid}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment[0].department_name}`)
        }
        if (this.state.searchByParentGroup && filterParentGroup.length > 0) {
            FilterArray.push(`Parent Group - ${filterParentGroup[0]}`)
        }
        if (this.state.searchBySemester && filterGroup.length > 0) {
            FilterArray.push(`Group - ${filterGroup[0]}`)
        }
        if (this.state.searchByUserName && filterStudentName.length > 0) {
            FilterArray.push(`Learner Name - ${filterStudentName[0].name} | ${filterStudentName[0].username}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllUserWiseIssueReturnResource" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                User Wise Issued Return Resources
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="10" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Type</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Resource Type</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Accession Series</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Accession No.</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Issue Date</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Due Date</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Return Date</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Applicable Fine</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Collected Fine</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Waived Fine</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Balance Fine</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Policy Name</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="12">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((userData, index) => {
                                    return (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{userData?.resourcePeriodicalType.charAt(0).toUpperCase() + userData?.resourcePeriodicalType.slice(1) || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{userData?.resourceType || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{userData?.accession_series || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{userData?.accessionnumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{userData?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{userData?.issued_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{userData?.due_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{userData?.return_date || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{userData?.fine_amount || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{userData?.collected_fine || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{userData?.waived_fine_amount || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{userData?.balance_fine_amount || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{userData?.policyName || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="12">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalDataItem } = this.state;
        const totalPages = Math.ceil(totalDataItem / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let userIdValue = this.state.searchByUserName ? (this.state.searchByUserName).value : '';
            let userRoleValue = ''
            if (this.state.searchByUserName.role == "Teaching") {
                userRoleValue = "teaching"
            } else if (this.state.searchByUserName.role == "Non-teaching") {
                userRoleValue = "nonteaching"
            } else {
                userRoleValue = "student"
            }

            let requestData = {
                "iid": config.institute_id,
                "pageIndex": pageIndex,
                "limitPerPage": 50,
                "userId": userIdValue,
                "Role": userRoleValue
            }

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'GetUserWiseIssuedResourceListForReport',
                requestData,
                '/api/library/instructor.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;

                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalRecords,
                    }, () => {

                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterUserType = this.state.userType
        let filterAcademicYear = Object.values(this.state.academicYearArray)?.filter((data) => data?.yearID == this.state.searchByAcademicYear)
        let filterProgram = Object.entries(this.state.programListArray)
            ?.filter(([id, data]) => id == this.state.searchByProgram)
            .map(([id, data]) => data.stream_name)
        let filterUserName = Object.values(this.state.employeeListData)?.filter((data) => data?.FacultyId == this.state.searchByUserName.value)
        let filterDepartment = Object.values(this.state.GetStreamList)?.filter((data) => data?.unique_id == this.state.searchByDepartment)
        let filterParentGroup = Object.entries(this.state.parentGroupListArray)
            ?.filter(([id, data]) => id == this.state.searchByParentGroup)
            .map(([id, data]) => data.groupName)
        let filterGroup = Object.entries(this.state.semesterListArray)
            ?.filter(([id, data]) => id == this.state.searchBySemester)
            .map(([id, data]) => data.groupName)
        let filterStudentName = Object.values(this.state.studentListData)?.filter((data) => data?.id == this.state.searchByUserName.value)

        if (filterUserType) {
            FilterArray.push(`User Type - ${filterUserType}`)
        }
        if (this.state.searchByAcademicYear && filterAcademicYear.length > 0) {
            FilterArray.push(`Academic Year - ${filterAcademicYear[0].yearName}`)
        }
        if (this.state.searchByProgram && filterProgram.length > 0) {
            FilterArray.push(`Program - ${filterProgram[0]}`)
        }
        if (this.state.searchByUserName && filterUserName.length > 0) {
            FilterArray.push(`Instructor Name - ${filterUserName[0].FirstName} ${filterUserName[0].LastName} | ${filterUserName[0].usertextid}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment[0].department_name}`)
        }
        if (this.state.searchByParentGroup && filterParentGroup.length > 0) {
            FilterArray.push(`Parent Group - ${filterParentGroup[0]}`)
        }
        if (this.state.searchBySemester && filterGroup.length > 0) {
            FilterArray.push(`Group - ${filterGroup[0]}`)
        }
        if (this.state.searchByUserName && filterStudentName.length > 0) {
            FilterArray.push(`Learner Name - ${filterStudentName[0].name} | ${filterStudentName[0].username}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        {/* header */}
                        <div className="d-flex col-md-12 px-0">
                            <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                {/* action button - filter */}
                                <div className="d-flex">
                                    <div>
                                        <label className="vm_custom_body3" color='#454E52'>
                                            User <span className='text-danger'>*</span>
                                        </label>
                                        <div className="input-group input-group-field" style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                            <div style={{ marginRight: '15px' }}>
                                                <input
                                                    type="radio"
                                                    name="userType"
                                                    checked={this.state.userType == 'Instructor'}
                                                    onChange={() => this.setState({
                                                        userType: 'Instructor', searchByAcademicYear: '', searchByProgram: '', searchByUserName: '', limit: "10", pageIndex: 1,
                                                        userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {}, employeeListData: {}, searchEmployeeMember: '',
                                                        searchByDepartment: '', searchByParentGroup: '', searchBySemester: ''
                                                    }, () => {
                                                        this.GetInstituteStreamsObject()
                                                    })}
                                                    style={{ marginRight: 5 }}
                                                />
                                                <span style={{ fontSize: 13 }}>Instructor</span>
                                            </div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    name="userType"
                                                    checked={this.state.userType == 'Learner'}
                                                    onChange={() => this.setState({
                                                        userType: 'Learner', searchByAcademicYear: '', searchByProgram: '', searchByUserName: '', limit: "10", pageIndex: 1,
                                                        userWiseIssueReturnListLoading: false, userWiseIssueReturnListData: {}, employeeListData: {}, searchEmployeeMember: '',
                                                        searchByDepartment: '', searchByParentGroup: '', searchBySemester: ''
                                                    })}
                                                    style={{ marginRight: 5 }}
                                                />
                                                <span style={{ fontSize: 13 }}>Learner</span>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() =>
                                        this.setState({
                                            showFilterModal: !this.state.showFilterModal
                                        })
                                    }><FontAwesomeIcon size='sm' icon={["fa", "filter"]} /> Filter</button> */}
                                </div>
                            </div>
                            {
                                Object.keys(this.state.userWiseIssueReturnListData).length == 0 ? null :
                                    <div className="col-md-6 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex align-items-center">
                                            {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                        </div>

                                        {/* 1 action button - export data */}
                                        <div className="d-flex ml-2" title="Click to Export" >
                                            <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                {"@page { size: auto; }"}
                                            </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                            {/* 2.1 action button option - export and export all */}
                                            <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                <span>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="export"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="userWiseIssueReturnReport"
                                                            filename="UserWiseIssuedReturnResourceData"
                                                            sheet="tablexls"
                                                            buttonText="Export to Excel "
                                                        >
                                                        </ReactHTMLTableToExcel>
                                                    </div>
                                                    <div style={{ display: 'none' }}>
                                                        <ReactHTMLTableToExcel
                                                            id="exportAll"
                                                            className="btn outline-button waves-effect text-capitalize"
                                                            table="ExportAllUserWiseIssueReturnResource"   // export all functionality
                                                            filename="ExportAllUserWiseIssuedReturnResourceData"
                                                            sheet="tablexls"
                                                            buttonText="Export All to Excel"
                                                        />
                                                    </div>
                                                    <button
                                                        onClick={this.formatCSVExportData}
                                                        className="dropdown-item"
                                                        title="Click to Export"
                                                        style={{ boxShadow: 'none' }}
                                                    >
                                                        Export
                                                    </button>
                                                    {this.state.isExportAllReportDataFetching ? (
                                                        <p className="dropdown-item">
                                                            Exporting report . . .&nbsp;
                                                            <FontAwesomeIcon
                                                                icon={["fas", "circle-notch"]}
                                                                className="rotate"
                                                            />
                                                        </p>
                                                    ) : (
                                                        <button
                                                            onClick={() => this.setState({ allReportData: {} }, () => {
                                                                this.methodToExportReportData(0)
                                                            })}
                                                            className="dropdown-item"
                                                            title="Click to Export All"
                                                            style={{ boxShadow: 'none' }}
                                                        >
                                                            Export All
                                                        </button>
                                                    )}
                                                </span>

                                            </div>

                                        </div>

                                        {/* 2 action button - print */}
                                        <div className="d-flex ml-2" title="Click to Print">
                                            <span className="print-button">
                                                <ReactToPrint
                                                    trigger={() => {
                                                        return (
                                                            <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                <style type="text/css" media="print">
                                                                    {"@page { size: auto; }"}
                                                                </style>
                                                                <span>
                                                                    <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                </span>
                                                            </div>
                                                        )
                                                    }}
                                                    content={() => this.componentRef}
                                                />
                                            </span>
                                        </div>

                                        {/* 3 action button - column visibility */}
                                        <div className="d-flex ml-2" title="Click to Customize Columns">
                                            <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />

                                            {/* action modal - column visibility*/}
                                            <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                {/* id='settingDropdown' */}
                                                <div className='settingDropdown-body'>
                                                    {
                                                        this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                            return (
                                                                <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                    <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                    <input type="checkbox" checked={columnInfo.isVisible} />
                                                                </p>
                                                            );
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                            }
                        </div>

                        {/* filter fields */}
                        <div>
                            {/* Based On Search User Type */}
                            {/* {this.state.showFilterModal && */}
                            {/* <div style={{ width: '100%' }}>
                                <div className="d-flex col-md-12" style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                    <div className="col-md-6 d-flex justify-content-start align-items-center p-0">
                                        <div className="mb-2 p-1">
                                            <label className="vm_custom_body3" color='#454E52'>
                                                User <span className='text-danger'>*</span>
                                            </label>
                                            <div className="input-group input-group-field" style={{ position: 'relative', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                                <div style={{ marginRight: '15px' }}>
                                                    <input
                                                        type="radio"
                                                        name="userType"
                                                        checked={this.state.userType == 'Instructor'}
                                                        onChange={() => this.setState({ userType: 'Instructor', searchByAcademicYear: '', searchByUserName: '' })}
                                                        style={{ marginRight: 5 }}
                                                    />
                                                    <span style={{ fontSize: 13 }}>Instructor</span>
                                                </div>
                                                <div>
                                                    <input
                                                        type="radio"
                                                        name="userType"
                                                        checked={this.state.userType == 'Learner'}
                                                        onChange={() => this.setState({ userType: 'Learner', searchByAcademicYear: '', searchByProgram: '', searchByUserName: '' })}
                                                        style={{ marginRight: 5 }}
                                                    />
                                                    <span style={{ fontSize: 13 }}>Learner</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* } */}

                            {this.state.userType == "Instructor" ?
                                // User Type : Instructor
                                <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}>
                                    <div style={{ width: '100%' }}>
                                        {/* filter data form*/}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                            <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                {/* Based on academic year */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Academic Year</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByProgramFilter"
                                                            onChange={this.handleInstructorAcdYearChange} // Attach handler here
                                                            value={this.state.searchByAcademicYear} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Academic Year</option>
                                                            {
                                                                Object.keys(this.state.academicYearList).length > 0 &&
                                                                this.state.academicYearSequence.map(yearId => {
                                                                    let year = this.state.academicYearList[yearId];
                                                                    return (
                                                                        <option value={yearId} key={yearId}>{year.year_text}</option>
                                                                    );
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on department */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Department</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleInstructorProgramChange} // Attach handler here
                                                            value={this.state.searchByProgram} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Department</option>
                                                            {Object.entries(this.state.programListArray).map(([id, stream]) => (
                                                                <option key={id} value={id} title={stream?.stream_name}>
                                                                    {stream?.stream_name?.length > 30 ? `${stream?.stream_name.substring(0, 30)}...` : stream?.stream_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on user */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>User Name</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        {/* <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleFilterUserChange}
                                                            onInputChange={(inputValue) => {
                                                                this.setState({ searchEmployeeMember: inputValue }, () => {
                                                                    this.getEmployeeDetails(); // Trigger the API call after updating the search term
                                                                }, 200);
                                                            }}
                                                            value={this.state.searchByUserName} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select User</option>
                                                            {Object.values(this.state.employeeListData).map((item) => (
                                                                <option key={item.FacultyId} value={item.FacultyId}>
                                                                    {`${item.FirstName} ${item.LastName} | ${item.usertextid}`}
                                                                </option>
                                                            ))}
                                                        </select> */}

                                                        <Select
                                                            // options={
                                                            //     Object.values(this.state.employeeListData).map(item => ({
                                                            //         value: item.FacultyId,
                                                            //         label: `${item.FirstName} ${item.LastName} | ${item.usertextid}`,
                                                            //         role: item.employeeRole,
                                                            //     }))
                                                            // }
                                                            options={
                                                                this.state.searchByProgram ? // Check if department is selected
                                                                    Object.values(this.state.employeeListData).map(item => ({
                                                                        value: item.FacultyId,
                                                                        label: `${item.FirstName} ${item.LastName} | ${item.usertextid}`,
                                                                        role: item.employeeRole,
                                                                    })) : // If department is selected, show employee options
                                                                    [{ value: '', label: 'Select department to get data', isDisabled: true }] // Default option if no department is selected
                                                            }
                                                            value={this.state.searchByUserName}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                this.setState({
                                                                    searchByUserName: event || '', // Handle empty selection
                                                                }, () => {
                                                                    // Check if there's a valid selection
                                                                    if (event) {
                                                                        this.GetUserWiseIssuedResourceListForReport();  // Call the API to fetch data
                                                                    } else {
                                                                        this.setState({
                                                                            userWiseIssueReturnListData: {}
                                                                        })
                                                                    }
                                                                });
                                                            }}
                                                            onInputChange={(inputValue) => {
                                                                this.setState({ searchEmployeeMember: inputValue }, () => {
                                                                    this.getEmployeeDetails(); // Trigger the API call after updating the search term
                                                                }, 200);
                                                            }}
                                                            placeholder="Select User"
                                                            isSearchable
                                                            isClearable
                                                            isLoading={this.state.loadingEmployeeData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }

                            {this.state.userType == "Learner" ?
                                // User Type : Learner
                                <div className="card" style={{ boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF' }}>
                                    <div style={{ width: '100%' }}>
                                        {/* filter data form*/}
                                        <div style={{ display: 'flex', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                            <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                {/* Based on academic year */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Academic Year</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByProgramFilter"
                                                            onChange={this.handleLeanerAcdYearChange} // Attach handler here
                                                            value={this.state.searchByAcademicYear} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Academic Year</option>
                                                            {
                                                                Object.keys(this.state.academicYearList).length > 0 &&
                                                                this.state.academicYearSequence.map(yearId => {
                                                                    let year = this.state.academicYearList[yearId];
                                                                    return (
                                                                        <option value={yearId} key={yearId}>{year.year_text}</option>
                                                                    );
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on department */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Department</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleDepartmentChange} // Attach handler here
                                                            value={this.state.searchByDepartment} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select Department</option>
                                                            {Object.values(this.state.GetStreamList).map((stream) => (
                                                                <option key={stream?.unique_id} value={stream?.unique_id} title={stream?.department_name} >
                                                                    {stream?.department_name?.length > 30 ? `${stream?.department_name.substring(0, 10)}...` : stream?.department_name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on program */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Program</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleLearnerProgramChange} // Attach handler here
                                                            value={this.state.searchByProgram} // Bind dropdown value to state
                                                        >
                                                            {/* {this.state.searchByDepartment ? ( */}
                                                            <>
                                                                <option value="">Select Program</option>
                                                                {Object.values(this.state.programListArray).length > 0 ? (
                                                                    Object.entries(this.state.programListArray).map(([id, stream]) => (
                                                                        <option key={id} value={id} title={stream?.stream_name}>
                                                                            {stream?.stream_name?.length > 30 ? `${stream?.stream_name.substring(0, 30)}...` : stream?.stream_name}
                                                                        </option>
                                                                    ))
                                                                ) : (
                                                                    <option value="" disabled>No data found</option>
                                                                )}
                                                            </>
                                                            {/* ) : (
                                                                <option value="" disabled>
                                                                    Select department to get program data
                                                                </option>
                                                            )} */}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on parent group */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Parent Group</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleParentGroupChange} // Attach handler here
                                                            value={this.state.searchByParentGroup} // Bind dropdown value to state
                                                        >
                                                            {this.state.searchByProgram ? (
                                                                <>
                                                                    <option value="">Select Parent Group</option>
                                                                    {Object.values(this.state.parentGroupListArray).length > 0 ? (
                                                                        Object.entries(this.state.parentGroupListArray).map(([id, stream]) => (
                                                                            <option key={id} value={id} title={stream?.groupName}>
                                                                                {stream?.groupName?.length > 30 ? `${stream?.groupName.substring(0, 30)}...` : stream?.groupName}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="" disabled>No data found</option>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <option value="" disabled>
                                                                    Select program to get parent group data
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on semester/group */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>Group</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '165px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchBySemester"
                                                            onChange={this.handleFilterSemesterChange} // Attach handler here
                                                            value={this.state.searchBySemester} // Bind dropdown value to state
                                                        >
                                                            {/* Check if both parent group and Academic Year are selected */}
                                                            {this.state.searchByAcademicYear && this.state.searchByParentGroup ? (
                                                                <>
                                                                    <option value="">Select Group</option>
                                                                    {Object.values(this.state.semesterListArray).length > 0 ? (
                                                                        Object.entries(this.state.semesterListArray).map(([id, stream]) => (
                                                                            <option key={id} value={id} title={stream?.groupName}>
                                                                                {stream?.groupName?.length > 30 ? `${stream?.groupName.substring(0, 30)}...` : stream?.groupName}
                                                                            </option>
                                                                        ))
                                                                    ) : (
                                                                        <option value="" disabled>No data found</option>
                                                                    )}
                                                                </>
                                                            ) : (
                                                                <option value="" disabled>
                                                                    Select academic year & parent group to get group data
                                                                </option>
                                                            )}
                                                        </select>
                                                    </div>
                                                </div>

                                                {/* Based on student */}
                                                <div className="mb-2 p-1">
                                                    <label className="vm_custom_body3" color='#454E52'>User Name</label>
                                                    <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                        {/* <select
                                                            className="form-control formControlContentTask"
                                                            style={{
                                                                // width: 'auto',
                                                                width: '200px',
                                                                height: '42px',
                                                                fontSize: "12px",
                                                                fontWeight: 400,
                                                                lineHeight: '20px',
                                                                fontFamily: "'Poppins', sans-serif",
                                                                color: '#808080',
                                                                borderRadius: '7px'
                                                            }}
                                                            id="searchByDepartmentFilter"
                                                            onChange={this.handleFilterUserChange}
                                                            value={this.state.searchByUserName} // Bind dropdown value to state
                                                        >
                                                            <option value="">Select User</option>
                                                            {Object.values(this.state.studentListData).map((item) => (
                                                                <option key={item.id} value={item.id}>
                                                                    {`${item.name} | ${item.username}`}
                                                                </option>
                                                            ))}
                                                        </select> */}

                                                        <Select
                                                            options={
                                                                // this.state.searchByAcademicYear && this.state.searchByDepartment &&
                                                                this.state.searchBySemester ? // Check if department is selected
                                                                    Object.values(this.state.studentListData).map(item => ({
                                                                        value: item.id,
                                                                        label: `${item.name} | ${item.username}`,
                                                                    })) : // If department is selected, show employee options
                                                                    [{ value: '', label: 'Select group to get data', isDisabled: true }] // Default option if no department is selected
                                                            }
                                                            value={this.state.searchByUserName}
                                                            className="basic-multi-select-filter"
                                                            onChange={(event) => {
                                                                this.setState({
                                                                    searchByUserName: event || '', // Handle empty selection
                                                                }, () => {
                                                                    // Check if there's a valid selection
                                                                    if (event) {
                                                                        this.GetUserWiseIssuedResourceListForReport();  // Call the API to fetch data
                                                                    } else {
                                                                        this.setState({
                                                                            userWiseIssueReturnListData: {}
                                                                        })
                                                                    }
                                                                });
                                                            }}
                                                            placeholder="Select User"
                                                            isSearchable
                                                            isClearable
                                                            isLoading={this.state.loadingEmployeeData} // Show loading spinner while fetching
                                                            styles={{
                                                                control: (base) => ({
                                                                    ...base,
                                                                    width: '100%',
                                                                    minHeight: 42, // Minimum height for the control area
                                                                    height: 'auto', // Allow control to grow dynamically
                                                                }),
                                                                menu: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                }),
                                                                menuPortal: (base) => ({
                                                                    ...base,
                                                                    zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                }),
                                                                placeholder: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                }),
                                                                option: (base, state) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: 400,
                                                                    backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                    color: state.isSelected ? '#333' : '#555',
                                                                }),
                                                                singleValue: (base) => ({
                                                                    ...base,
                                                                    fontSize: '12px',
                                                                    fontWeight: '400',
                                                                }),
                                                            }}
                                                            menuPortalTarget={document.body}
                                                        />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                :
                                null
                            }

                            {
                                (this.state.searchByAcademicYear !== '' || this.state.searchByProgram !== '' || this.state.searchByUserName !== '' || this.state.searchByDepartment !== '' || this.state.searchByParentGroup !== '' || this.state.searchBySemester !== '') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>User Wise Issued Return Resources</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="userWiseIssueReturnReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        User Wise Issued Return Resources
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="10" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Type</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Resource Type</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Accession Series</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Accession No.</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Issue Date</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Due Date</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Return Date</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Applicable Fine</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Collected Fine</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Waived Fine</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Balance Fine</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Policy Name</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.userWiseIssueReturnListLoading ? <tr>
                                                    <td colSpan="12">
                                                        <ButtonLoader />
                                                    </td>
                                                </tr> :
                                                    this.state.userType === "Instructor" &&
                                                        !this.state.searchByAcademicYear &&
                                                        !this.state.searchByProgram &&
                                                        !this.state.searchByUserName ? (
                                                        <tr>
                                                            <td colSpan="12" style={{ textAlign: "center" }}>
                                                                Please select Academic Year, Department, User Name to view instructor data.
                                                            </td>
                                                        </tr>
                                                    ) :
                                                        this.state.userType === "Learner" &&
                                                        !this.state.searchByAcademicYear  &&
                                                        !this.state.searchByProgram &&
                                                        !this.state.searchByDepartment  &&
                                                        !this.state.searchByParentGroup  &&
                                                        !this.state.searchBySemester &&
                                                        !this.state.searchByUserName ? (
                                                            <tr>
                                                                <td colSpan="12" style={{ textAlign: "center" }}>
                                                                    Please select Academic Year, Department, Program, Parent Group, Group, User Name to view learner data.
                                                                </td>
                                                            </tr>
                                                        ) :
                                                            Object.keys(this.state.userWiseIssueReturnListData).length > 0 ?
                                                                (Object.values(this.state.userWiseIssueReturnListData).map((userData, index) => (
                                                                    <tr key={index}>
                                                                        <td>{
                                                                            this.state.limit === 'all' ? index + 1 :
                                                                                ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                        }</td>
                                                                        {this.state.exportItemVisibilityForRows[0].isVisible && <td>{userData?.resourcePeriodicalType.charAt(0).toUpperCase() + userData?.resourcePeriodicalType.slice(1) || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[1].isVisible && <td>{userData?.resourceType || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[2].isVisible && <td>{userData?.accession_series || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[3].isVisible && <td>{userData?.accessionnumber || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[4].isVisible && <td>{userData?.title || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[5].isVisible && <td>{userData?.issued_date || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[6].isVisible && <td>{userData?.due_date || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[7].isVisible && <td>{userData?.return_date || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[8].isVisible && <td>{userData?.fine_amount || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[9].isVisible && <td>{userData?.collected_fine || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[10].isVisible && <td>{userData?.waived_fine_amount || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[11].isVisible && <td>{userData?.balance_fine_amount || ""}</td>}
                                                                        {this.state.exportItemVisibilityForRows[12].isVisible && <td>{userData?.policyName || ""}</td>}
                                                                    </tr>
                                                                ))) :
                                                                <tr>
                                                                    <td colSpan="12">
                                                                        No data found.
                                                                    </td>
                                                                </tr>
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {
                                (Object.keys(this.state.userWiseIssueReturnListData).length > 0 || Object.keys(this.state.userWiseIssueReturnListData).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id="" value={this.state.limit} onChange={this.changeShowEntriesControl}>
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalDataItem}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalDataItem || 0}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                    </div >
                </div>
            </div >

        );
    }
}

const mapStateToProps = store => {
    return {
        iidArray: { ...store.RouteMenuReducer.iidArray },
        multipleInstituteDetails: { ...store.RouteMenuReducer.multipleInstituteDetails }
    };
};


export default connect(mapStateToProps)(UserWiseIssuedReturnResource);;